import { render, staticRenderFns } from "./ConstructionAsset.vue?vue&type=template&id=707b4168&scoped=true&"
import script from "./ConstructionAsset.vue?vue&type=script&lang=js&"
export * from "./ConstructionAsset.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionAsset.vue?vue&type=style&index=0&id=707b4168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b4168",
  null
  
)

export default component.exports